import {
    cleanCommonParams,
    mapProductsParams,
    mapStatesParams,
    mapImageParams,
    mapSecondImageParams,
    mapSalesChannelsParams,
    mapCollateralLogosParams,
} from './common';

const mapCollateralTemplateParams = (
    isCreate,
    {
        products,
        states,
        image,
        second_image,
        sales_channels,
        applicable_collateral_logo_ids,
        expired_at,
        preview_image_source,
        pricing_info,
        collateral_category,
        cart_items,
        front_preview_url,
        back_preview_url,
        limited_pdf_url,
        pdf_url,
        is_swag_category,
        ...params
    },
) => {
    return new Promise((resolve) => {
        resolve({
            collateral_template: {
                ...cleanCommonParams(params),
                ...mapProductsParams(isCreate, products),
                ...mapStatesParams(isCreate, states),
                ...mapImageParams(isCreate, image),
                ...mapSecondImageParams(isCreate, second_image),
                ...mapSalesChannelsParams(isCreate, sales_channels),
                ...mapCollateralLogosParams(isCreate, applicable_collateral_logo_ids),
            },
        });
    });
};

export { mapCollateralTemplateParams };
